// src/components/Auth/ChangePasswordPage.tsx
import React, { useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { useNavigate } from "react-router-dom";
import Banner from "../../ui/Banner/Banner";
import { getAuth, updatePassword } from "firebase/auth";
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";
import landingimg from "../../../assets/images/Login-main.png";
import landinglogo from "../../../assets/images/landinglogo.svg";
import ErrorTooltip from "./ErrorTooltip";


const ChangePasswordPage: React.FC = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string>("");
  const [errors, setErrors] = useState<{
    newPassword?: string;
    confirmPassword?: string;
    form?: string;
  }>({});
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { currentUser, finalizePasswordChange } = useAuth();
  const navigate = useNavigate();

  const Eye = BsFillEyeFill as any;
  const CloseEye = BsFillEyeSlashFill as any;

  const finalizePasswordChangeOnServer = async () => {
    console.log("Attempting to finalize password change on server...");
    await currentUser?.getIdTokenResult(true);
    console.warn("Server-side flag clearing not implemented in this example.");
    return true;
  };

  // const handleChangePassword = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setError("");

  //   if (!newPassword || !confirmPassword) {
  //     setError("Please fill in both password fields.");
  //     return;
  //   }

  //   if (newPassword !== confirmPassword) {
  //     setError("Passwords do not match.");
  //     return;
  //   }

  //   if (newPassword.length < 6) {
  //     setError("Password must be at least 6 characters long.");
  //     return;
  //   }

  //   if (!currentUser) {
  //     setError("No user session found. Please log in again.");
  //     navigate("/login");
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     await updatePassword(currentUser, newPassword);
  //     console.log("Firebase password updated successfully.");

  //     // 2. Clear the requirement flag on the server (using callable function)
  //     const finalized = await finalizePasswordChange(); // Call the centralized function

  //     if (finalized) {
  //       // 3. Navigate to the main application area upon success
  //       navigate("/login", { replace: true });
  //     }

  //   } catch (err: any) {
  //     console.error("Change Password Error:", err);
  //     if (err.code === 'auth/requires-recent-login') {
  //       setError("This operation is sensitive and requires recent authentication. Please log in again.");
  //     } else if (err.code === 'auth/weak-password') {
  //       setError("Password is too weak. Please choose a stronger password.");
  //     }
  //     else {
  //       setError("Failed to update password. Please try again.");
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});

    // 🔴 FORM / SESSION LEVEL FIRST
    if (!currentUser) {
      setErrors({
        form: "No user session found. Please log in again.",
      });
      navigate("/login");
      return;
    }

    const newErrors: any = {};

    // 🔴 FIELD VALIDATIONS
    if (!newPassword) {
      newErrors.newPassword = "Please enter a new password.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    if (newPassword && newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    try {
      await updatePassword(currentUser, newPassword);
      await finalizePasswordChange();
      navigate("/login", { replace: true });

    } catch (err: any) {
      console.error("Change Password Error:", err);

      // 🔴 ALL SERVER ERRORS → FORM LEVEL
      if (err.code === "auth/requires-recent-login") {
        setErrors({
          form:
            "This operation is sensitive and requires recent authentication. Please log in again.",
        });
      } else if (err.code === "auth/weak-password") {
        setErrors({
          newPassword:
            "Password is too weak. Please choose a stronger password.",
        });
      } else {
        setErrors({
          form: "Failed to update password. Please try again.",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="mt-8 space-y-6 max-w-[600px] mx-auto w-full p-8 bg-white shadow-md rounded-lg">
          <h2 className="text-2xl font-semibold text-gray-900 text-center">
            Change Your Password
          </h2>
          <p className="text-sm text-gray-600 text-center">
            Please set a new password to continue accessing your account.
          </p>
          {error && (
            <div className="mt-4">
              <Banner dismissBanner={() => setError("")} message={error} status="error" />
            </div>
          )}
          <form onSubmit={handleChangePassword} className="mt-4 space-y-4">
            <div>
              <label
                htmlFor="newPassword"
                className="block text-sm font-medium text-gray-700"
              >
                New Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="newPassword"
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md pr-10"
                  required
                  autoComplete="new-password"
                />
                <div
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                >
                  {showNewPassword ? (
                    <Eye className="text-xl" />
                  ) : (
                    <CloseEye className="text-xl" />
                  )}
                </div>
              </div>
            </div>
            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm New Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md pr-10"
                  required
                  autoComplete="new-password"
                />
                <div
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                >
                  {showConfirmPassword ? (
                    <Eye className="text-xl" />
                  ) : (
                    <CloseEye className="text-xl" />
                  )}
                </div>
              </div>
            </div>
            <div>
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${isLoading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
              >
                {isLoading ? "Updating..." : "Set New Password"}
              </button>
            </div>
          </form>
        </div>
      </div> */}

      <div className="!h-[100vh] "
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >

        {/* LEFT SECTION */}
        <div className="flex flex-col justify-center px-8 md:px-20 lg:px-28 py-10 w-full"
          style={{ alignItems: "center", justifyContent: "center" }}
        >

          {/* Logo */}
          <div className="mb-10  flex justify-start w-full max-w-lg">
            <img src={landinglogo} alt="landinglogo" className="h-10 w-auto" />
          </div>

          {/* Card */}
          <div className="w-full max-w-lg">
            <div className="bg-white">
              <div className="mb-4 xl:mb-8">
                <h1 className="text-3xl font-semibold text-gray-900">Change Your Password</h1>
                <p className="text-[#777777] mt-1">Please set a new password to continue accessing your account.</p>
              </div>

              <form onSubmit={handleChangePassword} className="mt-10 space-y-7">

                <div className="relative">
                  {errors.form && (
                    <div className="relative mb-6">
                      <ErrorTooltip message={errors.form} />
                    </div>
                  )}
                  {errors.newPassword && (
                    <ErrorTooltip message={errors.newPassword} />
                  )}

                  <div className="flex flex-col gap-3">
                    <label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                      New Password
                    </label>
                    <div className="relative w-full">
                      <input
                        id="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                        className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                        style={{
                          border: errors.newPassword
                            ? "1px solid #d34a4f"
                            : "1px solid #ccc",
                        }}
                      />

                      <div
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                      >
                        {showNewPassword ? (
                          <Eye className="text-[#718096] text-xl" />
                        ) : (
                          <CloseEye className="text-[#718096] text-xl" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="relative">
                  {errors.confirmPassword && (
                    <ErrorTooltip message={errors.confirmPassword} />
                  )}

                  <div className="flex flex-col gap-3">
                    <label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                      Confirm new password
                    </label>
                    <div className="relative w-full">
                      <input
                        id="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                        className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                        style={{
                          border: errors.confirmPassword
                            ? "1px solid #d34a4f"
                            : "1px solid #ccc",
                        }}
                      />

                      <div
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                      >
                        {showConfirmPassword ? (
                          <Eye className="text-[#718096] text-xl" />
                        ) : (
                          <CloseEye className="text-[#718096] text-xl" />
                        )}
                      </div>
                    </div>

                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="mt-[50px] block w-full bg-[#7E57C2] text-white text-center hover:bg-[#6b46ac] !rounded-[10px] !py-[14px] !px-[22px] text-base no-underline cursor-pointer !text-[16px] !font-medium"
                  >
                    {isLoading ? "Updating..." : "Set New Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <img src={landingimg} alt="landingimg" className="min-w-fit h-full hidden lg:block" />
      </div>

    </>
  );
};

export default ChangePasswordPage;